let navigation = $ => {
  let $btn = $('#burger-button');
  let $menuItemBtn = $('.navigation__item-btn');
  let $body = $('body');

  $btn.on('click', function () {
    if (!$body.hasClass('navigation-opened')) {
      $body.addClass('navigation-opened js-is-prevent-scroll');
    } else {
      $body.removeClass('navigation-opened js-is-prevent-scroll');
    }
  });

  $menuItemBtn.on('click', function () {
    let $thisEl = $(this);
    let $parent = $thisEl.parents('.navigation__item').eq(0);

    if (!$parent.hasClass('navigation__item--active')) {
      $parent.addClass('navigation__item--active');
      $thisEl.siblings('.navigation__sublist').stop().slideDown();
    } else {
      $parent.removeClass('navigation__item--active');
      $thisEl.siblings('.navigation__sublist').stop().slideUp();
    }
  });
};

export default navigation;



// WEBPACK FOOTER //
// ./app/blocks/navigations/navigations.js